import React from "react";
import Heading from "./Heading";
import { pastaAndSandwiches } from "./sandwichesData.js";

function PastaAndSandwiches() {
  return (
    <>
      <a href="#" id="sandwiches"></a>
      <div className="w-full p-4 h-fit font-fancy">
        <Heading heading="Pasta & Sandwiches" />
        {pastaAndSandwiches.map((pastaAndSandwiche) => {
          return (
            <React.Fragment key={pastaAndSandwiche.id}>
              <div className="flex justify-start gap-5 p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                <h3 className="text-base font-bold grow">
                  {pastaAndSandwiche.name}
                </h3>
                <p className="px-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                  {pastaAndSandwiche.priceS}
                </p>
                {pastaAndSandwiche.priceL !== "" && (
                  <p className="px-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                    {pastaAndSandwiche.priceL}
                  </p>
                )}
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}

export default PastaAndSandwiches;
